import { render } from "./MailLog.vue?vue&type=template&id=12f9cbd8&scoped=true&ts=true"
import script from "./MailLog.vue?vue&type=script&lang=ts"
export * from "./MailLog.vue?vue&type=script&lang=ts"

import "./MailLog.vue?vue&type=style&index=0&id=12f9cbd8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f9cbd8"]])

export default __exports__